/**
 * This is a workaround script that moves the markup for our ribbon
 * into its correct place right as direct descendant of .owl-item in the slider.
 */
export default class Ribbon {
	constructor(el) {
		if (typeof el === 'string') {
			const elements = document.querySelectorAll(el);
			// eslint-disable-next-line no-console
			console.log(`[Ribbon] Found ${elements.length} ribbon(s)`);
			elements.forEach((element) => {
				this.el = element;
				this.move();
			});
		} else if (el) {
			this.el = el;
			this.move();
		}
	}

	move() {
		const parent = this.el.closest('.owl-item');
		if (parent) {
			parent.insertBefore(this.el, parent.firstChild);
			// eslint-disable-next-line no-console
			console.log('[Ribbon] Moved ribbon to .owl-item', this.el);
		} else {
			// eslint-disable-next-line no-console
			console.warn('[Ribbon] No .owl-item parent found for', this.el);
		}
	}

	static moveAll(container = document) {
		const ctx =
			typeof container === 'string'
				? document.querySelector(container)
				: container;
		if (ctx) {
			ctx.querySelectorAll('.ribbon').forEach((el) => new Ribbon(el));
		}
	}
}
